import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import ReactPaginate from 'react-paginate';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { reportResponseService } from '../../../services/ResponsesLaw544Service';

class AdminResponsesLaw544 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newResponse: {
        title: '',
        document: '',
        date: ''
      },
      existingResponses: [],
      deleteResponse: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }
  componentWillMount() {
    reportResponseService
      .getAll()
      .then(response => {
        this.setResponseState(response);
      })
      .catch(error => {
        console.log(error);
      });
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  setResponseState = response => {
    let existingResponses = this.state.existingResponses;
    existingResponses = response.aplicability_report_answers;
    this.setState({
      existingResponses
    });
    let pagination = { ...this.state.pagination };
    pagination = response.pagination;
    this.setState({
      pagination
    });
  };
  handlePageClick = currentPage => {
    reportResponseService
      .getAll(currentPage.selected + 1)
      .then(response => {
        this.setResponseState(response);
      })
      .catch(error => console.log(error));
  };
  updateField = event => {
    const field = event.target.name;
    let newResponse = { ...this.state.newResponse };
    newResponse[field] = event.target.value;
    this.setState({
      newResponse
    });
  };
  resetForm = () => {
    let newResponse = { ...this.state.newResponse };
    newResponse = {
      title: '',
      document: '',
      date: ''
    };
    this.setState({ newResponse });
    this.setState({ disabledDocument: false });
  };
  openDeleteDialog = id => {
    let deleteResponse = { ...this.state.deleteResponse };
    deleteResponse = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteResponse });
  };

  closeDeleteDialog = () => {
    let deleteResponse = { ...this.state.deleteResponse };
    deleteResponse = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteResponse });
  };
  handleFormSubmit = event => {
    event.preventDefault();

    reportResponseService
      .createOrUpdate(this.state.newResponse)
      .then(response => {
        this.resetForm();

        let existingResponses = this.state.existingResponses;

        let index = existingResponses.findIndex(
          existingResponses => existingResponses.id === response.id
        );

        if (index !== -1) {
          existingResponses[index] = response;
        } else {
          existingResponses.push(response);
        }

        this.setState({
          existingResponses
        });

        this._notificationSystem.addNotification({
          message: `Raspunsul a fost ${
            this.state.newResponse.id ? 'editat' : 'adaugat'
          } cu success.`,
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };
  onDropDocument = documents => {
    let newResponse = { ...this.state.newResponse };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newResponse.document = documents[0];

      self.setState({ newResponse });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newResponse = { ...this.state.newResponse };
    newResponse.document = null;

    this.setState({ newResponse });
    this.setState({ disabledDocument: false });
  };

  setResponseForEdit = response => {
    let newResponse = { ...this.state.newResponse };
    newResponse = Object.assign({}, response);
    this.setState({ newResponse });

    if (newResponse.document && newResponse.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  handleDelete = () => {
    reportResponseService
      .deleteResponse(this.state.deleteResponse.deleteId)
      .then(() => {
        let existingResponses = this.state.existingResponses.slice();
        existingResponses = existingResponses.filter(
          regulament => regulament.id !== this.state.deleteResponse.deleteId
        );
        this.setState({ existingResponses });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Raspunsul a fost sters cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la stergere, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">
            Raspunsuri furnizate in baza legii 544/2011
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adaugă un raspuns:</h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu document*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newResponse.title}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată document*
                  </h4>
                  <input
                    className="general-field date-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newResponse.date}
                  />
                </div>

                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newResponse.document}
                    documentFilename={this.state.newResponse.document_filename}
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newResponse.id
                        ? 'Editează Document'
                        : 'Adaugă Document'}
                    </button>
                  </div>
                  {Object.values(this.state.newResponse) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingResponses &&
            this.state.existingResponses.length > 0 && (
              <div className="admin-standard-page__existing-items">
                <div className="card">
                  <div className="existing-items">
                    <h2 className="existing-items__title label-title">
                      Raspunsuri existente
                    </h2>
                    <div className="existing-items__content">
                      {this.state.existingResponses.map(response => (
                        <div
                          className="existing-items__content-card"
                          key={response.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {response.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() => this.setResponseForEdit(response)}
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() => this.openDeleteDialog(response.id)}
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <DeletePUGCertificates
                      opened={this.state.deleteResponse.openedDialog}
                      handleClose={this.closeDeleteDialog}
                      handleDelete={this.handleDelete}
                      headline="Sunteti sigur ca doriti sa stergeti acest document?"
                      aditionalText="Dupa stergere, acest document nu va mai putea fi recuperata."
                    />
                  </div>
                  {this.state.pagination.last_page > 1 && (
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={this.state.pagination.last_page}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  )}
                </div>
              </div>
            )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}
export default AdminResponsesLaw544;
